module.exports = __webpack_public_path__ + "img/logo_signet.8c15b1cb.png";